import { Component, Input } from "@angular/core";
import { Align } from "@tylertech/tyler-api-types";
import { MetadataTextButtonComponent } from "./metadata-text-button.component";

@Component({
    selector: "metadata-link",
    templateUrl: "./metadata-link.tmpl.html",
    standalone: false
})
export class MetadataLinkComponent extends MetadataTextButtonComponent
{
    get layout(): string
    {
        switch(this.propertyMetadata.Alignment)
        {
            case Align.Right:
                return "layout-end";
                
            case Align.Center:
                return "layout-center";
            
            case Align.Left:
            default:                
                return "layout-start";
        }
    }

    get id(): string
    {
        return `link-${this.propertyMetadata.Name}`;
    }
}
